import { store } from '@betacrew/jars-flux';
import { all, call, put,select, takeLatest } from 'redux-saga/effects';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import { addNotifications } from '../../toaster/ToasterPortalSlice'; 
import { PAGE_STATE } from '../../constants/constants';
import { componentKey, setLoadingState, setUploadedFile } from './FileShareSlice';
import ShortcutDataService from '../../../../services/ShortcutsDataService';
import { FILE_SHARE_LOADING_STATE } from './constants';

export const { uploadFile } = {
    uploadFile: (payload) => {
        return {
            type: "FILESHARE/UPLOAD_SHEET",
            payload: payload
        }
    },
}

function* uploadFileAsync(action) {

    try {
        yield put(setLoadingState({ state: FILE_SHARE_LOADING_STATE.LOADING }))
        const uploadedFile = action.payload;

        const formData = new FormData();
        formData.append("file", uploadedFile);

        const response = yield ShortcutDataService.uploadFile(formData);

        if (response?.data.Status === 1) {
            const saveResponse = yield ShortcutDataService.sendFile();
            if(saveResponse.data.Status === 1) {
                yield put(addNotifications({ 
                    heading: "Success", 
                    message: saveResponse.data.Message,
                    variant: TOASTER_VARIANT.SUCCESS }));
            }
            else {
                yield put(addNotifications({ heading: "Error Sharing File", message: saveResponse?.data?.Message }));
            }
        } else {
            yield put(addNotifications({ heading: "Something went wrong, file not uploaded successfully", message: response?.data?.Message }));
        }

    } catch (error) {

        yield put(addNotifications({ heading: "Failed to upload a file", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: FILE_SHARE_LOADING_STATE.READY }))
        yield put(setUploadedFile(null))
    }

}

function* rootSaga() {
    yield all([
        takeLatest(uploadFile().type, uploadFileAsync),
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);